import React from 'react'

import styles from './Block.module.scss'

const Block = ({ title, children }) => (
    <li className={styles.block}>
        {!!title && <h4 className={styles.title}>{title}</h4>}
        <ul className={styles.items}>{children}</ul>
    </li>
)

export default Block
